(() => {
  const callback = () => {
    if (!window.themeComponents.snippets.register('multi-selectors')) return;

    const selectors = {
      disclosureListItemCurrent: '.disclosure-list__item--current',
    };

    const scrollToCurrentItem = (event) => {
      const { disclosureList, isExpanded } = event.detail ?? {};
      const currentCurrency = disclosureList?.querySelector(selectors.disclosureListItemCurrent);

      if (isExpanded && currentCurrency) disclosureList.scrollTop = currentCurrency.offsetTop;
    };

    document.addEventListener('disclosure:toggled', scrollToCurrentItem);
  };

  document.addEventListener('DOMContentLoaded', callback);
})();
